export { default as PromocodeQuery } from "./PromocodeQuery.graphql";
